import React, { useState , useEffect} from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../Components/common/utils";
const CreatAd = () => {
    const [formData, setFormData] = useState({
        title: "",
        email: "",
        category_id: '',
        short_description: "",
        long_description: "",
        address: "",
    });
    const [categoryList, setCategoryList] = useState([]);
    const [file, setFile] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const userdetail = JSON.parse(localStorage.getItem("UserData"));
    const navigate = useNavigate();
      useEffect(() => {
            const fetchApiData = async () => {
                const url = "api/company/logo"; // Change this to your category API
                const result = await fetchData(url);
                if (result && result.data) {
                    setCategoryList(result.data);
                }
              
            };
            fetchApiData();
        }, []);
    // Handle input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle file upload
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    // Validate form
    const validateForm = () => {
        let tempErrors = {};
        if (!formData.title) tempErrors.title = "Title is required";
        if (!formData.email) {
            tempErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            tempErrors.email = "Email is invalid";
        }
        if (!formData.short_description) tempErrors.short_description = "Short description is required";
        if (!formData.long_description) tempErrors.long_description = "Long description is required";
        if (!formData.category_id) tempErrors.category_id = "Category is required";
        if (!formData.address) tempErrors.address = "Address is required";
        if (!file) tempErrors.file = "Image is required";

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    // Submit form
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);

        try {
            const data = new FormData();
            Object.keys(formData).forEach((key) => {
                data.append(key, formData[key]);
            });
            data.append("adds_image", file);
            data.append("register_id", userdetail?.id);

            const response = await fetch("https://admin.energybazzar.com/api/user/adds", {
                method: "POST",
                body: data, // ✅ send as FormData (not JSON)
            });
            const result = await response.json();
            if (result.status === true) {
                toast.success("Ad created successfully!");
                setFormData({
                    title: "",
                    email: "",
                    category_id:'',
                    short_description: "",
                    long_description: "",
                    address: "",
                })
                setFile(null);
                navigate('/dashboard')
            }

            // console.log(result.data);
        } catch (err) {
            console.error(err);
            toast.error("Error creating ad");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="container mt-5">
            <h3 className="mb-4">Create Ad</h3>
            <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Title</label>
                        <input
                            type="text"
                            name="title"
                            className={`form-control ${errors.title ? "is-invalid" : ""}`}
                            value={formData.title}
                            onChange={handleChange}
                        />
                        <div className="invalid-feedback">{errors.title}</div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            name="email"
                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                            value={formData.email}
                            onChange={handleChange}
                        />
                        <div className="invalid-feedback">{errors.email}</div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Short Description</label>
                        <input
                            type="text"
                            name="short_description"
                            className={`form-control ${errors.short_description ? "is-invalid" : ""}`}
                            value={formData.short_description}
                            onChange={handleChange}
                        />
                        <div className="invalid-feedback">{errors.short_description}</div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Address</label>
                        <input
                            type="text"
                            name="address"
                            className={`form-control ${errors.address ? "is-invalid" : ""}`}
                            value={formData.address}
                            onChange={handleChange}
                        />
                        <div className="invalid-feedback">{errors.address}</div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Category</label>
                        <select
                            className={`form-select ${errors.category_id ? 'is-invalid' : ''}`}
                            name="category_id"
                            value={formData.category_id}
                            onChange={handleChange}
                        >
                            <option value="">Select Category</option>
                            {categoryList.map((item) => (
                                <option key={item.id} value={item.id}>{item.title}</option>
                            ))}
                        </select>
                        <div className="invalid-feedback">{errors.category_id}</div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-12">
                        <label className="form-label">Long Description</label>
                        <textarea
                            name="long_description"
                            className={`form-control ${errors.long_description ? "is-invalid" : ""}`}
                            value={formData.long_description}
                            onChange={handleChange}
                        />
                        <div className="invalid-feedback">{errors.long_description}</div>
                    </div>
                </div>

                <div className="mb-3">
                    <label className="form-label">Upload Image</label>
                    <input
                        type="file"
                        className={`form-control ${errors.file ? "is-invalid" : ""}`}
                        onChange={handleFileChange}
                        accept="image/jpeg, image/jpg, image/png"
                        multiple={false}
                    />
                    <div className="invalid-feedback">{errors.file}</div>
                </div>

                <button type="submit" className="btn btn-primary px-5" disabled={loading}>
                    {loading ? (
                        <div className="spinner-border spinner-border-sm" role="status"></div>
                    ) : (
                        "Submit"
                    )}
                </button>
            </form>
        </div>
    );
};

export default CreatAd;
